import i18n from "i18next"
import { initReactI18next } from "react-i18next"
import translationPTBR from "./locales/pt-br/translation.json"

// pt-BR only. The template's other locales (gr/it/rs/sp/eng) were never
// reachable from the UI and only added weight to the bundle.
i18n
  .use(initReactI18next)
  .init({
    resources: { ptbr: { translation: translationPTBR } },
    lng: "ptbr",
    fallbackLng: "ptbr",
    keySeparator: false, // keys are plain sentences
    interpolation: { escapeValue: false }, // React already escapes
  })

export default i18n
